
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code4 } from "./data";

export default defineComponent({
  name: "small-pagination",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code4
    };
  }
});
